export default __webpack_public_path__ + "static/media/TrackIcon.16e3e7a8.svg";